import clsx from 'clsx';
import React from 'react';
import {Checkbox as DSCheckbox} from '@lightricks/react-design-system';
import styles from './Checkbox.module.scss';

const checkboxCheckedSrc = '/assets/svg/checkbox-checked.svg';
const checkboxUncheckedSrc = '/assets/svg/checkbox-unchecked.svg';
const checkboxUncheckedLightSrc = '/assets/svg/checkbox-unchecked-light.svg';
const checkboxPartialSrc = '/assets/svg/checkbox-partial.svg';

const stopPropagation = (event: React.MouseEvent) => {
  event.stopPropagation();
};

type CheckboxVariant = 'default' | 'light';

interface CheckboxProps {
  testID?: string;
  checked: boolean;
  indeterminate?: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  variant?: CheckboxVariant;
  shouldStopPropagation?: boolean;
}

function Checkbox({
  testID = 'checkbox',
  checked,
  indeterminate,
  onChange,
  className,
  variant = 'default',
  shouldStopPropagation = true,
}: CheckboxProps) {
  const uncheckedSrc =
    variant === 'light' ? checkboxUncheckedLightSrc : checkboxUncheckedSrc;

  return (
    <div
      className={clsx(styles.checkboxWrapper, className)}
      onClick={shouldStopPropagation ? stopPropagation : undefined}
      data-testid={testID}
    >
      <DSCheckbox
        checked={checked}
        indeterminate={indeterminate}
        onChange={onChange}
        customCheckedIcon={
          <img
            data-testid={`${testID}--checked`}
            src={checkboxCheckedSrc}
            alt=""
          />
        }
        customUncheckedIcon={
          <img data-testid={`${testID}--unchecked`} src={uncheckedSrc} alt="" />
        }
        indeterminateIcon={<img src={checkboxPartialSrc} alt="" />}
      />
    </div>
  );
}

export default Checkbox;
